
export function isComWx() {
  return /wxwork/i.test(navigator.userAgent) || /wechatdevtools/i.test(navigator.userAgent)
}

export function isPhone(phone) {
  return /^1[3|4|5|7|8|9][0-9]\d{4,8}$/.test(phone)
}